import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { APIs } from "../../utils/worker";
import ShipmentDetails from "../../shipment-detail-tracking/shipment-details";

import BagDetails from "../../shipment-detail-tracking/bag-details";

const { trackingURL } = APIs;

const IframeShipmentTracker = () => {
  const location = useLocation();
  const { awb } = location?.state || {};
  const [activeTab, setActiveTab] = useState("new"); // 'old' | 'new'

  // Reset to "new" tab whenever AWB changes (new search)
  React.useEffect(() => {
    setActiveTab("new");
  }, [location.state]);

  const renderNewLevel = () => {
    if (awb && awb.length > 11) {
      return <ShipmentDetails awbNumber={awb} />;
    } else if (awb && awb.length === 11) {
      return <BagDetails awbNumber={awb} />;
    }
    // Default fallback or empty state if needed
    return <div style={{ padding: "20px" }}>No details available for this AWB.</div>;
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ padding: "10px", display: "flex", gap: "10px", background: "#f0f2f5" }}>
        <button
          onClick={() => setActiveTab("new")}
          style={{
            padding: "8px 16px",
            cursor: "pointer",
            fontWeight: activeTab === "new" ? "bold" : "normal",
            backgroundColor: activeTab === "new" ? "#fff" : "transparent",
            border: "1px solid #d9d9d9",
            borderRadius: "4px"
          }}
        >
          <span className="blink-new-tab">New</span>
        </button>
        <button
          onClick={() => setActiveTab("old")}
          style={{
            padding: "8px 16px",
            cursor: "pointer",
            fontWeight: activeTab === "old" ? "bold" : "normal",
            backgroundColor: activeTab === "old" ? "#fff" : "transparent",
            border: "1px solid #d9d9d9",
            borderRadius: "4px"
          }}
        >
          Old
        </button>
      </div>

      {activeTab === "old" ? (
        <iframe
          src={awb ? `${trackingURL}/track-order/${awb}` : `${trackingURL}/`}
          style={{ flex: 1, border: "none", width: "100%", height: "100%" }}
          title="Shree Maruti Shipment Tracker"
          allowFullScreen
        ></iframe>
      ) : (
        <div style={{ flex: 1, overflow: "auto" }}>
          {renderNewLevel()}
        </div>
      )}
    </div>
  );
};

export default IframeShipmentTracker;
